const dummyText = 'Sobre a Nivele Mais...';

export default dummyText;